// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-plannings-structure {
  position: relative;
  width: 100%;
  max-width: 1158px;
  margin: 0 auto;
}
.page-plannings-structure__header {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-plannings-structure__header-title {
  font-family: Campuni;
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-gray);
}
.page-plannings-structure__header .BaSe--button {
  min-height: 30px;
}
.page-plannings-structure__header .BaSe--button span {
  font-size: 13px;
}
.page-plannings-structure__filters {
  position: relative;
  margin-bottom: 16px;
}
.page-plannings-structure__filters .BaSe--select {
  width: 100%;
}
.page-plannings-structure__filters .BaSe--input-input, .page-plannings-structure__filters .BaSe--select-input {
  height: 36px;
}
.page-plannings-structure__filters .BaSe--input {
  max-width: 100%;
}
.page-plannings-structure__body {
  border-radius: 8px;
  border: 1px solid var(--sebrae-light-gray4);
  padding: 10px 12px;
}
.page-plannings-structure__tabs {
  position: relative;
  width: 100%;
  border-bottom: 1px solid var(--sebrae-white-4);
  margin-bottom: 24px;
  padding-bottom: 24px;
}
.page-plannings-structure__tabs-buttons {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-color: var(--sebrae-light-gray2) transparent !important;
}
.page-plannings-structure__tabs-buttons button {
  position: relative;
  width: auto;
  min-width: fit-content;
  padding: 16px 8px;
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-gray);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.page-plannings-structure__tabs-buttons button.active {
  font-weight: 700;
  color: var(--sebrae-blue-7);
}
@media screen and (min-width: 768px) {
  .page-plannings-structure__tabs-buttons button.active:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -3px;
    width: 100%;
    height: 6px;
    background: var(--sebrae-blue-7);
  }
}
.page-plannings-structure__tabs-order-by {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  width: 100%;
  max-width: 327px;
}
.page-plannings-structure__tabs-order-by__label {
  min-width: fit-content;
  font-size: 13px;
  color: var(--sebrae-dark-gray2);
}
.page-plannings-structure__tabs-order-by .BaSe--select {
  margin-bottom: 0 !important;
}
.page-plannings-structure__tabs-order-by .BaSe--select-input {
  padding: 0 30px 0 5px;
  height: 32px !important;
  font-size: 12px;
  color: var(--sebrae-dark-gray3);
}
.page-plannings-structure__tabs-order-by .BaSe--select-option {
  padding: 5px 12px;
}
.page-plannings-structure__tabs-order-by .BaSe--select .BaSe--paragraph {
  font-size: 12px;
}
.page-plannings-structure__tabs-order-by .BaSe--select > div:nth-of-type(1) {
  margin: 0;
}
.page-plannings-structure__tabs-order-by .BaSe--select > div:nth-of-type(2) {
  top: -3px;
}
@media screen and (min-width: 768px) {
  .page-plannings-structure__tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0;
  }
  .page-plannings-structure__tabs-buttons {
    overflow-x: unset;
  }
  .page-plannings-structure__tabs-order-by {
    margin: 0;
  }
}
@media screen and (min-width: 768px) {
  .page-plannings-structure__header-title {
    font-size: 27px;
  }
  .page-plannings-structure__header .BaSe--button {
    min-height: 40px;
  }
  .page-plannings-structure__header .BaSe--button span {
    font-size: 16px;
  }
  .page-plannings-structure__filters {
    display: flex;
    gap: 12px;
    width: 100%;
  }
  .page-plannings-structure__filters .BaSe--input-input, .page-plannings-structure__filters .BaSe--select-input {
    height: 40px !important;
  }
  .page-plannings-structure__filters .BaSe--input-list-container {
    margin-top: 25px;
    flex: auto;
  }
  .page-plannings-structure__filters .wrapper-select {
    flex: 1 1;
  }
  .page-plannings-structure__filters .BaSe--select {
    width: 210px;
  }
  .page-plannings-structure__body {
    padding: 16px 24px;
  }
}
@media screen and (min-width: 1024px) {
  .page-plannings-structure__filters {
    gap: 18px;
  }
  .page-plannings-structure__filters .BaSe--select {
    width: 290px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/page-plannings-structure/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EAEI,oBAAA;EACA,eAAA;EACA,gBAAA;EAEF,yBAAA;AADN;AAGI;EACE,gBAAA;AADN;AAGM;EACE,eAAA;AADR;AAKE;EACE,kBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAKI;EACE,YAAA;AAHN;AAKI;EACE,eAAA;AAHN;AAME;EACE,kBAAA;EACA,2CAAA;EACA,kBAAA;AAJJ;AAME;EACE,kBAAA;EACA,WAAA;EACA,8CAAA;EACA,mBAAA;EACA,oBAAA;AAJJ;AAMI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;AAJN;AAMM;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,kDAAA;AANR;AAQQ;EACE,gBAAA;EACA,2BAAA;AANV;AASQ;EAEI;IACE,WAAA;IACA,kBAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;IACA,gCAAA;EARZ;AACF;AAaI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAXN;AAaM;EACE,sBAAA;EACA,eAAA;EACA,+BAAA;AAXR;AAcM;EACE,2BAAA;AAZR;AAcQ;EACE,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;AAZV;AAcQ;EACE,iBAAA;AAZV;AAcQ;EACE,eAAA;AAZV;AAcQ;EACE,SAAA;AAZV;AAcQ;EACE,SAAA;AAZV;AAiBI;EAnFF;IAoFI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,iBAAA;EAdJ;EAgBI;IACE,iBAAA;EAdN;EAgBI;IACE,SAAA;EAdN;AACF;AAkBE;EAEI;IACE,eAAA;EAjBN;EAmBI;IACE,gBAAA;EAjBN;EAmBM;IACE,eAAA;EAjBR;EAqBE;IACE,aAAA;IACA,SAAA;IACA,WAAA;EAnBJ;EAqBI;IACE,uBAAA;EAnBN;EAqBI;IACE,gBAAA;IACA,UAAA;EAnBN;EAqBI;IACE,SAAA;EAnBN;EAqBI;IACE,YAAA;EAnBN;EAsBE;IACE,kBAAA;EApBJ;AACF;AAsBE;EACE;IACE,SAAA;EApBJ;EAsBI;IACE,YAAA;EApBN;AACF","sourcesContent":[".page-plannings-structure {\n  position: relative;\n  width: 100%;\n  max-width: 1158px;\n  margin: 0 auto;\n\n  &__header {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n\n    &-title {\n      font: {\n        family: Campuni;\n        size: 16px;\n        weight: 700;\n      }\n      color: var(--sebrae-gray);\n    }\n    .BaSe--button {\n      min-height: 30px;\n\n      span {\n        font-size: 13px;\n      }\n    }\n  }\n  &__filters {\n    position: relative;\n    margin-bottom: 16px;\n\n    .BaSe--select {\n      width: 100%;\n    }\n    .BaSe--input-input, .BaSe--select-input {\n      height: 36px;\n    }\n    .BaSe--input {\n      max-width: 100%;\n    }\n  }\n  &__body {\n    border-radius: 8px;\n    border: 1px solid var(--sebrae-light-gray4);\n    padding: 10px 12px;\n  }\n  &__tabs {\n    position: relative;\n    width: 100%;\n    border-bottom: 1px solid var(--sebrae-white-4);\n    margin-bottom: 24px;\n    padding-bottom: 24px;\n\n    &-buttons {\n      display: flex;\n      flex-wrap: nowrap;\n      overflow-x: auto;\n      scrollbar-color: var(--sebrae-light-gray2) transparent!important;\n\n      button {\n        position: relative;\n        width: auto;\n        min-width: fit-content;\n        padding: 16px 8px;\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n        color: var(--sebrae-gray);\n        transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n        &.active {\n          font-weight: 700;\n          color: var(--sebrae-blue-7);\n        }\n\n        @media screen and (min-width: 768px) {\n          &.active {\n            &:after {\n              content: '';\n              position: absolute;\n              left: 0;\n              bottom: -3px;\n              width: 100%;\n              height: 6px;\n              background: var(--sebrae-blue-7);\n            }\n          }\n        }\n      }\n    }\n    &-order-by {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      margin-top: 5px;\n      width: 100%;\n      max-width: 327px;\n\n      &__label {\n        min-width: fit-content;\n        font-size: 13px;\n        color: var(--sebrae-dark-gray2);\n      }\n\n      .BaSe--select {\n        margin-bottom: 0!important;\n\n        &-input {\n          padding: 0 30px 0 5px;\n          height: 32px!important;\n          font-size: 12px;\n          color: var(--sebrae-dark-gray3);\n        }\n        &-option {\n          padding: 5px 12px;\n        }\n        .BaSe--paragraph {\n          font-size: 12px;\n        }\n        > div:nth-of-type(1) {\n          margin: 0;\n        }\n        > div:nth-of-type(2) {\n          top: -3px;\n        }\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-bottom: 0;\n\n      &-buttons {\n        overflow-x: unset;\n      }\n      &-order-by {\n        margin: 0;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    &__header {\n      &-title {\n        font-size: 27px;\n      }\n      .BaSe--button {\n        min-height: 40px;\n\n        span {\n          font-size: 16px;\n        }\n      }\n    }\n    &__filters {\n      display: flex;\n      gap: 12px;\n      width: 100%;\n\n      .BaSe--input-input, .BaSe--select-input {\n        height: 40px!important;\n      }\n      .BaSe--input-list-container {\n        margin-top: 25px;\n        flex: auto;\n      }\n      .wrapper-select {\n        flex: 1;\n      }\n      .BaSe--select {\n        width: 210px;\n      }\n    }\n    &__body {\n      padding: 16px 24px;\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    &__filters {\n      gap: 18px;\n\n      .BaSe--select {\n        width: 290px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
